import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
  useEffect,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { Service } from "../../../graphql/models";
import { ServiceForm } from "./service_form";

import userServiceStyle from "./services.style";
import { useLoggedUserInfo, useSnackbarQuery } from "../../../hooks";
import {
  ServiceCategory,
  ServiceCategoryGqlResponse,
} from "./types/serviceCategory.type";

function AmenitiesPage() {
  const classes = userServiceStyle();

  const tableRef = useRef();

  const { isAdminUser, isServiceProviderUser } = useLoggedUserInfo();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formService, setFormService] = useState<Service | undefined>(void 0);

  const addNewService = () => {
    setFormService({} as Service);
    setFormDialogOpened(true);
  };

  const editService = (row) => {
    setFormService({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormService(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback(
    (row) => {
      const actions: ReactNode[] = [];
      if (isAdminUser || isServiceProviderUser) {
        actions.push(
          <EditButton key="editService" onClick={() => editService(row)} />
        );
      }

      return actions;
    },
    [isAdminUser, isServiceProviderUser]
  );

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    if (isAdminUser) {
      actions.push(
        <Button
          key="addNewService"
          variant="contained"
          color="primary"
          onClick={() => addNewService()}
        >
          Aggiungi Nuovo
        </Button>
      );
    }
    return actions;
  }, [isAdminUser]);

  const { data: serviceCategoriesData } =
    useSnackbarQuery<ServiceCategoryGqlResponse>(QUERIES.SERVICE_CATEGORIES);

  const [serviceCategories, setServiceCategories] = useState<ServiceCategory[]>(
    []
  );

  useEffect(() => {
    if (!serviceCategoriesData) return;

    setServiceCategories(serviceCategoriesData.serviceCategories);
  }, [serviceCategoriesData]);

  const onServiceCategoryCreate = useCallback(
    (serviceCategory: ServiceCategory) =>
      setServiceCategories((pv) => [...pv, serviceCategory]),
    []
  );

  const onServiceCategoryUpdate = useCallback(
    (serviceCategory: ServiceCategory) =>
      setServiceCategories((pv) =>
        [...pv].map((v) => (v.id === serviceCategory.id ? serviceCategory : v))
      ),
    []
  );

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar title={"Servizi"} actions={actionToolbarActions} />

        <GqlTable
          ref={tableRef}
          columns={["", "Nome", "Descrizione", "Ordine"].map((v, index) => (
            <TableCell key={index}>{v}</TableCell>
          ))}
          query={QUERIES.BACKOFFICE_SERVICES}
          queryResultDataField="backofficeServices"
          rows={(row: Service) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.description}</TableCell>
              <TableCell>{row.sortIndex ?? "-"}</TableCell>
            </>
          )}
        />

        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica Service"}
        >
          <ServiceForm
            value={formService}
            serviceCategories={serviceCategories}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
            onServiceCategoryCreate={onServiceCategoryCreate}
            onServiceCategoryUpdate={onServiceCategoryUpdate}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(AmenitiesPage);
